<template>
  <div class="d-flex align-center flex-wrap ga-1">
    <span
      ref="stock"
      class="font-weight-medium"
      :class="loadingRealtimePrices ? 'text-grey' : 'text-' + getStockStatusColor(stock.status)"
    >
      {{
        (showStockCount && stock.count ? stock.count + ' ' : '') + $t('stockStatus.' + stock.status)
      }}
    </span>
    <template v-if="stock.deliveryDate">
      <span ref="delivery-date">{{ stock.deliveryDate }}</span>
      <sf-info-tooltip :aria-label="$t('additionalStockInfos')">
        {{ $t('productStockInfo.onStock', [stock.count]) }},
        <template v-if="stock.incomingAmount">
          {{ $t('productStockInfo.onSupply', [stock.incomingAmount]) }},
        </template>
        {{ $t('productStockInfo.nextDeliveryB2B', [stock.deliveryDate]) }}
      </sf-info-tooltip>
    </template>
  </div>
</template>

<script setup lang="ts">
import SfInfoTooltip from '@/components/tooltip/SfInfoTooltip.vue'
import { SimpleStock } from '@/generatedTypes'
import { getStockStatusColor } from '@/modules/product/helpers'
import { PropType } from 'vue'

defineProps({
  stock: {
    type: Object as PropType<SimpleStock>,
    required: true
  },
  loadingRealtimePrices: {
    type: Boolean,
    required: true
  },
  showStockCount: {
    type: Boolean,
    default: false
  }
})
</script>
